// hooks/useAppWrapperBg.ts
'use client'

import { useEffect } from 'react'

export function useChangeBaseColor(className: string) {
  useEffect(() => {
    const wrapper = document.querySelector('.ui--app-wrapper')
    if (!wrapper) return

    // Save current classes
    const prevClasses = wrapper.className

    // Add new class
    wrapper.classList.add(className)

    // Cleanup on unmount
    return () => {
      wrapper.classList.remove(className)
      wrapper.className = prevClasses
    }
  }, [className])
}
